export default __webpack_public_path__ + "static/media/habrImg3.1443e7d4.jpeg";